import axios from '@/axios'

export default {
  login(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/auth/login`, item)
        .then(response => {
          axios.defaults.headers.common.authorization = response.data.token
            ? `JWT ${response.data.token}`
            : ''
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  register(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/auth/register`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  adminRegister(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/auth/admin/register`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  forgotPassword(email) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/auth/reset-pass-request`, { email: email })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  verifyPasswordResetKey(key) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/auth/verify-reset-password-key`, { resetPassKey: key })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  resetPassword(key, password) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/auth/reset-password`, {
          resetPassKey: key,
          password: password
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  resendVerifyEmail(userId) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/auth/verify-resend`, {
          userId: userId
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  verifyEmail(verifyKey) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/auth/verify`, {
          verifyKey: verifyKey
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getCurrentUser() {
    return new Promise((resolve, reject) => {
      axios
        .post(`/auth/get-current-user`, {})
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  refreshToken() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/auth/refresh-token`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
